export class EventSubscriber<T> {
    private _map = new Map<string, Set<(arg?: T) => void>>();

    public unsubscribe(event: string, callback: (arg?: T) => void) {
        const callbackSet = this._map.get(event);
        callbackSet?.delete(callback);
        if (!callbackSet?.size) {
            this._map.delete(event);
        }
    }

    public subscribe(event: string, callback: (arg?: T) => void) {
        if (!this._map.has(event)) {
            this._map.set(event, new Set());
        }
        this._map.get(event)?.add(callback);

        return () => this.unsubscribe(event, callback);
    }

    public fire(event: string, arg?: T) {
        const callbackSet = this._map.get(event);
        if (!callbackSet) {
            return;
        }
        Array.from(callbackSet).forEach(cb => cb(arg));
    }
}
